/* eslint-disable @typescript-eslint/default-param-last */

import { SET_FEATURE_FLAGS } from './actions';

export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
